export const ROLE_LABELS = Object.freeze({
  owner: "Владелец",
  administrator: "Администратор",
  curator: "Куратор",
  user: "Читатель",
});

export const roleLabel = (role) => ROLE_LABELS[role] || ROLE_LABELS.user;
